import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { blockUser } from "../store/userSlice";
import { fetchAllPublicPosts } from "../store/postsSlice";
import { useAppDispatch } from "../hooks/useRedux";
import { toast } from "react-toastify";

const BlockUserModal = ({ visible, onClose, userId }) => {
  const [isBlocking, setIsBlocking] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleBlockUser = async () => {
    setIsBlocking(true);
    try {
      await dispatch(blockUser({ userId })).unwrap();
      onClose();
      try {
        await dispatch(fetchAllPublicPosts());
      } catch {
        toast.warn("User blocked, but failed to refresh posts.", {
          position: "top-right",
          autoClose: 4000,
        });
      }
      navigate(-1);
    } catch (error) {
      toast.error("Failed to block the user. Please try again.", {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      setIsBlocking(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-gray-800 w-80 rounded-lg p-5 text-white">
        {isBlocking ? (
          <div className="flex flex-col items-center justify-center p-5">
            <svg
              className="animate-spin h-8 w-8 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span className="mt-2 text-base">Blocking User...</span>
          </div>
        ) : (
          <>
            <h2 className="text-lg font-bold mb-4 text-center">
              Are you sure you want to block this user?
            </h2>
            <div className="flex justify-between mt-5">
              <button
                className="flex-1 bg-gray-600 rounded-md py-2 mx-1 text-base font-semibold hover:bg-gray-500 disabled:opacity-50"
                onClick={onClose}
                disabled={isBlocking}
              >
                Cancel
              </button>
              <button
                className="flex-1 bg-red-600 rounded-md py-2 mx-1 text-base font-semibold hover:bg-red-500 disabled:opacity-50"
                onClick={handleBlockUser}
                disabled={isBlocking}
              >
                Block
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BlockUserModal;
